import React from 'react';
import Footer from '../Footer';
import InternalError from '../InternalError';
import { MainContainer } from './styles';

interface Props {
  children: React.ReactNode;
  errorInRequest?: boolean;
}

export default function Container({ children, errorInRequest }: Props) {
  return (
    <>
      <MainContainer>
        {errorInRequest ? <InternalError /> : children}
      </MainContainer>
      <Footer />
    </>
  );
}
